/**
 * @Author: Tom Voorneveld <tom>
 * @Date:   2019-02-21T12:06:39+01:00
 * @Email:  tom@lorinthe.com
 * @Project: Lorinthe
  @Last modified by:   tom
  @Last modified time: 2019-05-11T12:16:08+02:00
 * @Copyright: (c) copyright Lorinthe BV, all rights reserved
 */

import Vue from 'vue'
import Vuex from 'vuex'

// the stores
import app from './modules/app'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    app
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
